import { render, staticRenderFns } from "./EditView.vue?vue&type=template&id=0e99c344"
import script from "@/views/modules/UserRoles/js/EditView.js?vue&type=script&lang=js&external"
export * from "@/views/modules/UserRoles/js/EditView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports